export const GET_USERS_SUMMARY = 'GET_USERS_SUMMARY';
export const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';
export const GET_NEW_USER_SIGN_UPS = 'GET_NEW_USER_SIGN_UPS';
export const GET_REFERRAL_STATS = 'GET_REFERRAL_STATS';
export const GET_ACTIVE_USER_AGE = 'GET_ACTIVE_USER_AGE';
export const GET_CUMULATIVE_USERS = 'GET_CUMULATIVE_USERS';
export const LOADING = 'LOADING';
